import React, { useState, useEffect, useRef } from 'react'
import FirstLevel from './components/firstLevel/FirstLevel'
import CheckBoxRadioButtonInput from '../forms/field/checkbox-radiobutton/CheckBoxRadioButtonInput'
import styles from './TreeView.module.scss'
import { useTranslation } from 'react-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBoxOpen } from '@fortawesome/pro-solid-svg-icons'

interface ITreeViewProps {
  data: any[]
  checked?: any[]
  onChange: any
}

const TreeView: React.FC<ITreeViewProps> = ({ data, checked = [], onChange }) => {
  const { t } = useTranslation()
  const [checkAll, setCheckAll] = useState(true)
  const [checkList, setCheckList] = useState(checked)
  const [allCheckedListAux, setAllCheckedListAux] = useState([] as any)
  const [blocksCount, setBlocksCount] = useState(0)
  const [lessonsCount, setLessonsCount] = useState(0)
  const firstLevelCheckBoxes = useRef([] as any)

  useEffect(() => {
    let auxLessonCount = 0
    let auxBlocksCount = 0
    const aux = data.map(({ id: lessonId, blocks }: any) => {
      const blockAux = [] as any
      auxLessonCount++
      setLessonsCount(lessonsCount + 1)
      blocks.map(({ id: blockId }: any) => {
        auxBlocksCount++
        blockAux.push(blockId)
      })
      return { lessonId, checked: true, blocks: blockAux }
    })

    setBlocksCount(auxBlocksCount)
    setLessonsCount(auxLessonCount)
    setCheckList(aux)
    setAllCheckedListAux(aux)
  }, [data, lessonsCount])

  const handleSelectAllClick = () => {
    const aux = allCheckedListAux.map((lesson: any) => {
      firstLevelCheckBoxes.current[lesson.lessonId].children[0].children[0].indeterminate = false
      return checkAll ? { ...lesson, checked: false, blocks: [] } : lesson
    })
    setCheckList(aux)
    setCheckAll(!checkAll)
  }

  const handleFirstLevelCheck = (id: number) => {
    const aux = checkList.slice()
    const isChecked = aux.findIndex((lesson: any) => lesson.lessonId === id && lesson.checked)
    if (isChecked >= 0) {
      aux[isChecked] = { ...aux[isChecked], checked: false, blocks: [] }
    } else {
      const index = aux.findIndex((lesson: any) => lesson.lessonId === id)
      aux[index] = allCheckedListAux.find((lesson: any) => lesson.lessonId === id)
    }
    setCheckList(aux)
    checkIfAllIsChecked(aux)
  }

  const handleDefaultLevelCheck = (id: number, blockId: number) => {
    const aux = checkList.slice()
    // FirstLevel
    const index = aux.findIndex((lesson: any) => lesson.lessonId === id)
    // SecondLevel
    const exist = aux[index].blocks.findIndex((block: any) => block === blockId)
    const item = firstLevelCheckBoxes.current[id].children[0].children[0]
    if (exist >= 0) {
      const newBlockList = aux[index].blocks.slice()
      newBlockList.splice(exist, 1)
      aux[index] = { ...aux[index], checked: false, blocks: newBlockList }
    } else {
      aux[index].blocks.push(blockId)
    }
    const isAllChecked = allCheckedListAux[index].blocks.length === aux[index].blocks.length
    item.indeterminate = !isAllChecked && aux[index].blocks.length > 0 ? true : false
    aux[index].checked = isAllChecked

    setCheckList(aux)
    checkIfAllIsChecked(aux)
  }

  useEffect(() => {
    onChange(checkList)
  // eslint-disable-next-line
  }, [checkList])

  const checkIfAllIsChecked = (newList: any) => {
    let aux = true
    newList.some((item: any) => {
      if (!item.checked) {
        aux = false
        return 'ok'
      }
    })
    setCheckAll(aux)
  }

  return (
    <>
      {lessonsCount > 0 && (
        <div className={`d-flex justify-content-between mb-4 `}>
          <div className="d-flex">
            <CheckBoxRadioButtonInput
              name="selectAll"
              value={false}
              label=""
              inline={false}
              type="checkbox"
              onChange={handleSelectAllClick}
              checked={checkAll}
              customLabel={<div className={styles.checkLabel}> {t('administration.courses.duplicate.selectAll')} </div>}
            />
          </div>

          <div className={styles.contentCount}>
            {lessonsCount} {t(`administration.courses.duplicate.lessons.${lessonsCount !== 1 ? 'plural' : 'singular'}`) + ' '}
            {t('administration.courses.duplicate.and')} {blocksCount} {t(`administration.courses.duplicate.blocks.${blocksCount !== 1 ? 'plural' : 'singular'}`)}
          </div>
        </div>
      )}
      <div className={styles.blocksContainer}>
        {data.length > 0 ? (
          data.map(({ id, name, blocks }: any, index: number) => {
            return (
              <FirstLevel
                key={'firstLevel' + index}
                id={id}
                addRef={(el: any) => {
                  firstLevelCheckBoxes.current[id] = el
                }}
                name={name}
                blocks={blocks}
                checked={checkList}
                onFirstLevelCheck={handleFirstLevelCheck}
                onDefaultLevelCheck={(blockId: any) => handleDefaultLevelCheck(id, blockId)}
              />
            )
          })
        ) : (
          <div className={styles.emptyList}>
            <FontAwesomeIcon icon={faBoxOpen} size="6x"></FontAwesomeIcon>
            <p className="m-0">{t('administration.courses.duplicate.emptyList')}</p>
          </div>
        )}
      </div>
    </>
  )
}

export default TreeView
